import axios from './axiosConfig'

export const loginUser = async (formData) => {
  const response = await axios.post('/admin/login', formData)

  console.log('Login response:', response.data)

  return response.data
}

export const verifyUser = async (formData) => {
  const response = await axios.post('/admin/login/verify', formData, {
    withCredentials: true,
  })

  return response.data
}

export const verifyToken = async () => {
  try {
    // Make the verification request to the server
    const response = await axios.get('/admin/verify', {
      withCredentials: true,
      headers: {
        'Cache-Control': 'no-cache',
      },
    })

    console.log('Server verification response:', response.data)

    // No localStorage updates

    return {
      status: true,
      data: response.data,
    }
  } catch (error) {
    console.error('Session verification failed:', error)
    return {
      status: false,
      error: error.response?.data?.message || error.message,
    }
  }
}

export const logoutUser = async () => {
  try {
    const response = await axios.post(
      '/admin/logout',
      {},
      { withCredentials: true }
    )

    // No need to clear localStorage

    return response.data
  } catch (error) {
    console.error('Logout failed:', error)
    throw error
  }
}
